import React from 'react'
import styles from '../../styles/modules/Dashboard.module.css';
import { MdOutlineTimelapse } from 'react-icons/md';
import { IoLocationSharp } from 'react-icons/io5';

const ScheduleCard = ({ schedule }) => {
    return (
        <div className={styles['schedule_card']}>
            <div className={styles['schedule_card_vertical_line']}></div>
            <div className={styles['schedule_card_head']}>
                <h3>
                    {new Date(schedule?.startTime).toLocaleDateString("en-US", { timeZone: 'UTC', month: 'short' })}
                </h3>
                <p>
                    {new Date(schedule?.startTime).toLocaleDateString("en-US", { timeZone: 'UTC', day: 'numeric' })}
                </p>
            </div>
            <div className={styles['schedule_card_details']}>
                <div className={styles['schedule_card_type_resource']}>
                    <h4>{schedule?.scheduleType?.replaceAll("_", " ")}</h4>
                    {schedule?.resourceName &&
                        <div className={styles['schedule_card_resource']}>{schedule?.resourceName}</div>}
                </div>
                {schedule?.subject && <h5>{schedule?.subject}</h5>}
                <div className={styles['schedule_card_venue']}>
                    <IoLocationSharp className={styles['venue_icon']} /><p>{schedule?.venue}</p></div>
                <div className={styles['schedule_card_timing_and_status']}>
                    <p className={styles['schedule_card_timing']}>
                        <MdOutlineTimelapse className={styles['schedule_card_timing_icon']} />
                        {new Date(schedule?.startTime).toLocaleTimeString("en-US", { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' })}
                        &nbsp;-&nbsp;
                        {new Date(schedule?.endTime).toLocaleTimeString("en-US", { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' })}
                    </p>
                    <div className={styles['schedule_card_status']}>{schedule?.scheduleStatus}</div>
                </div>
            </div>

        </div>
    )
}

export default ScheduleCard;